<template>
    <div class="component component__text_columns">
        <div class="columns is-variable is-6">
            <template v-for="(item, index) in items">
                <div
                    class="column is-narrow"
                    :key="index"
                >
                    <div v-if="item.label || item.icon" class="component__text_columns_label">
                        <v-icon
                            v-if="item.icon"
                            :name="item.icon"
                        ></v-icon>
                        <span v-if="item.label">{{ item.label }}</span>
                    </div>
                    <div
                        v-if="item.content !== undefined"
                        class="component__text_columns_value"
                    >{{ item.content }}</div>
                </div>
            </template>
            <div class="column"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'component-text-columns',
  props: {
    items: {
      /*
      * Array of Objects
      * {
      *     label: String,
      *     icon: String,
      *     content: String
      * }
      */
      type: Array
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenttextcolumns";
</style>
